import { render, staticRenderFns } from "./salesRuleDialog.vue?vue&type=template&id=cfa90ce2&scoped=true"
import script from "./salesRuleDialog.vue?vue&type=script&lang=js"
export * from "./salesRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./salesRuleDialog.vue?vue&type=style&index=0&id=cfa90ce2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa90ce2",
  null
  
)

export default component.exports